import { VideoConstraints } from '../types/index';

export const API_ENDPOINTS = {
  USERS: '/users',
  POSTS: '/posts',
};

export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
};

export const APP_CONFIG = {
  MAX_ITEMS_PER_PAGE: 10,
  DEFAULT_LANGUAGE: 'en',
}; 

export const VIDEO_CONSTRAINTS: VideoConstraints = {
  facingMode: "user",
  width: { ideal: 1280, max: 1920 },
  height: { ideal: 720, max: 1080 },
};

export const MIME_TYPES = [
  "video/webm;codecs=vp9,opus",
  "video/webm;codecs=vp8,opus",
  "video/webm",
  "video/mp4",
];

export const RECORDING_CHUNK_INTERVAL = 50;
export const PREVIEW_TIMEOUT = 2000;
export const STOP_RECORDING_DELAY = 100; 

export const ERROR_MESSAGES = {
  BROWSER_NOT_SUPPORTED: "Your browser does not support camera access. Please try a different browser.",
  CAMERA_ACCESS_FAILED: "Could not access your camera. Please check permissions and try again.",
  VIDEO_PLAYBACK_FAILED: "Could not start video playback",
  NO_STREAM_AVAILABLE: "Cannot start recording: No camera stream available",
  RECORDING_ERROR: "Recording error occurred. Please try again.",
  NO_DATA_RECORDED: "No video data was recorded. Please try again.",
  EMPTY_RECORDING: "Recorded video is empty. Please try again.",
  PROCESSING_ERROR: "Error processing recorded video",
  DEVICE_NOT_SUPPORTED: "Could not start recording. Your device may not support this feature.",
  PERMISSIONS_ERROR: "Could not access camera. Please check permissions, try using a different browser, or ensure no other app is using your camera.",
  CAMERA_IN_USE: "Could not start camera. Please check permissions and ensure no other app is using your camera.",
} as const;
export const PACIFIC_TIMEZONE = "America/Los_Angeles";